/**
 * Words in the name of an official race: a race of the Wimedo competition, run in groups with a
 * trophy at the end of the year, such as Wedstrijd #7 2026, TWONK #5 2026 or Wedstrijd 6 2025 TW-ONKA
 * @type {RegExp}
 */
const OFFICIAL_NAME = /wedstrijd|tw-?onk/i

/**
 * First day of the races to choose from; earlier races have incomplete names and times
 * @type {string}
 */
const FIRST_SHOWN_DAY = '2024-01-01'

/**
 * Check whether a race can be chosen: from 2024 on, as earlier races have incomplete data
 * @param {Object|null} contest race with the day of its laps or its planned date
 * @returns {boolean} whether the race is shown in the race list
 */
export const isShownRace = ( contest ) => Boolean( contest && ( contest.day || contest.date || '' ) >= FIRST_SHOWN_DAY )

/**
 * Check whether a race is official; other races, such as club days and trackdays, have no groups
 * @param {Object|null} contest race with its description
 * @returns {boolean} whether the race is official
 */
export const isOfficialRace = ( contest ) => Boolean( contest && OFFICIAL_NAME.test( contest.description || '' ) )
